import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findLeader',
})
export class FindLeaderPipe implements PipeTransform {
  transform(members: any[]): any {
    if (!members || !Array.isArray(members)) {
      return null;
    }
    return members.find((m) => m.isLeader) || null;
  }
}
